/** 签约合同在原页面按页预览；只在主动点击下载时读取原件，避免弹窗拦截触发自动下载。 */
import React, { useMemo, useRef, useEffect, useState } from "react";
import OperatingAttachmentPreview from "../finance/OperatingAttachmentPreview";
import { toast } from "../ui/sonner";

export default function SignedContractPreview({ api, leadId, preview, zh, onClose }) {
  const [downloading, setDownloading] = useState(false);
  const active = useRef(true);
  useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
  const file = useMemo(() => ({
    filename: preview.filename,
    type: "application/pdf",
    // 上传主件固定 fileId；无上传件时由后端读取签字版，逐份查看仍校验客户归属。
    loadPdfPage: async page => (await api.get(`/crm/signed/${leadId}/contract/preview-page`, {
      params: { page, ...(preview.fileId ? { fileId: preview.fileId } : {}) },
    })).data,
  }), [api, leadId, preview]);
  const download = async () => {
    setDownloading(true);
    try {
      const { data } = await api.get(preview.url, { responseType: "blob" });
      if (!active.current) return;
      const url = URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
      const anchor = document.createElement("a");
      anchor.href = url; anchor.download = preview.filename; anchor.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      if (active.current) toast.error(zh ? "合同下载失败，请重试。" : "Contract download failed. Please retry.");
    } finally { if (active.current) setDownloading(false); }
  };
  return <OperatingAttachmentPreview file={file} zh={zh} onClose={onClose}
    description={zh ? "签约合同预览" : "Signed contract preview"} testId="signed-contract-preview"
    onDownload={download} downloading={downloading}
    onCloseAutoFocus={event => { event.preventDefault(); preview.trigger?.focus(); }} />;
}
